import { useAppSelector } from "@app/hooks";
import { AdminNavItem } from "@fadmin/components/manageNavItem";
import { NavItems } from "@helpers/navigation";

export const ManageNav = (): JSX.Element => {
    const upcomingAssessments = useAppSelector((x) => x.orgLocations.upcomingAssessments?.length);
    const completedAssessments = useAppSelector((x) => x.orgLocations.completedAssessments?.items?.length);
    const remoteAssessments = useAppSelector((x) => x.orgLocations.remoteAssessments?.length);

    return (
        <div className="tabs is-boxed px-5 has-background-primary-dark is-size-7 has-text-weight-medium">
            <ul>
                <AdminNavItem item={NavItems.Admin.Assessments.Upcoming} itemCount={upcomingAssessments ?? 0} />
                <AdminNavItem item={NavItems.Admin.Assessments.Completed} itemCount={completedAssessments ?? 0} />
                <AdminNavItem item={NavItems.Admin.Assessments.Remote} itemCount={remoteAssessments ?? 0} />
            </ul>
        </div>
    );
};
